"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch as Toggle } from "@headlessui/react";
import clsx from "clsx";
import { forwardRef } from "react";
export type SwitchSize = "sm" | "md";
export type SwitchLabelPosition = "start" | "end";
export type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  name?: string | undefined;
  value?: string | undefined;
  labelPosition?: SwitchLabelPosition;
  size?: SwitchSize;
  fullWidth?: boolean;
};
const textSizes: Record<SwitchSize, string> = {
  sm: "text-app-body-2",
  md: "text-body-2"
};
const switchSizes: Record<SwitchSize, string> = {
  sm: "h-3s w-2m",
  md: "h-m w-l"
};
const dotSizes: Record<SwitchSize, string> = {
  sm: "h-2s w-2s",
  md: "h-[28px] w-[28px]"
};
const dotCheckedSizes: Record<SwitchSize, string> = {
  sm: "translate-x-s",
  md: "translate-x-3s"
};
const Switch = forwardRef<HTMLButtonElement, SwitchProps>(function Switch(t0, ref) {
  const $ = _c(38);
  let T0;
  let label;
  let labelEl;
  let labelPosition;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== ref || $[1] !== t0) {
    const {
      size: t9,
      label: t10,
      labelPosition: t11,
      fullWidth: t12,
      ...props
    } = t0;
    label = t10;
    const size = t9 === undefined ? "sm" : t9;
    labelPosition = t11 === undefined ? "start" : t11;
    const fullWidth = t12 === undefined ? false : t12;
    let t13;
    if ($[14] !== label || $[15] !== size) {
      t13 = label && <span className={textSizes[size]}>{label}</span>;
      $[14] = label;
      $[15] = size;
      $[16] = t13;
    } else {
      t13 = $[16];
    }
    labelEl = t13;
    const t14 = fullWidth && "w-full";
    if ($[17] !== t14) {
      t8 = clsx("flex items-center gap-xs", t14);
      $[17] = t14;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    T0 = Toggle;
    t3 = props;
    t4 = ref;
    t5 = props.name;
    const t15 = fullWidth && "w-full";
    if ($[19] !== t15) {
      t6 = clsx("flex items-center gap-2xs text-left", t15);
      $[19] = t15;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t7 = labelPosition === "start" && labelEl;
    t2 = clsx("relative flex flex-none items-center rounded-full p-[2px] transition", switchSizes[size], {
      "bg-primary-800": props.checked,
      "bg-neutral-150": !props.checked
    });
    t1 = clsx("inline-block transform rounded-full bg-neutral-0 transition", dotSizes[size], {
      [dotCheckedSizes[size]]: props.checked
    });
    $[0] = ref;
    $[1] = t0;
    $[2] = T0;
    $[3] = label;
    $[4] = labelEl;
    $[5] = labelPosition;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    T0 = $[2];
    label = $[3];
    labelEl = $[4];
    labelPosition = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[21] !== t1) {
    t9 = <span className={t1} />;
    $[21] = t1;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t2 || $[24] !== t9) {
    t10 = <div className={t2}>{t9}</div>;
    $[23] = t2;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = label && labelPosition === "end" && labelEl;
  let t12;
  if ($[26] !== T0 || $[27] !== t10 || $[28] !== t11 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7) {
    t12 = <T0 {...t3} ref={t4} data-testid={t5} className={t6}>{t7}{t10}{t11}</T0>;
    $[26] = T0;
    $[27] = t10;
    $[28] = t11;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[35] = t12;
    $[36] = t8;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
});
export default Switch;